<template>
  <!-- TODO: Show how the bed time in calculated. -->
  <ModalContainer
    v-model="modal"
    :title="title"
    :button="button"
    :disableClose="disableClose"
    @button-click="onButtonClick()"
  >
    <p>{{ text }}</p>
    <h3 class="mt-4 mb-0">Wake time</h3>
    <div @click="wakeTimepicker = true" class="inline-flex flex-row align-center justify-center gap-4 w-5/6 p-4 pl-8 pr-6 rounded-lg font-bold text-3xl text-slate-600 bg-gray-100 border">
      <span>{{ formatTime(timeWake) }}</span>
    </div>
    <h3 class="mt-4 mb-0">Bed time</h3>
    <div class="inline-flex flex-row align-center justify-center gap-4 w-5/6 p-4 pl-8 pr-6 rounded-lg font-bold text-3xl text-gray-400 bg-gray-100 border disabled">
      <span>{{ formatTime(timeBed) }}</span>
    </div>
    <div class="w-5/6 p-4 rounded-lg bg-blue-100 text-left">
      <span>Your bed time is updated based on wake time and sleep duration targets.</span>
    </div>
    <h3 class="mt-4 mb-0">Sleep duration</h3>
    <div @click="durationSelector = true" class="inline-flex flex-row align-center justify-center gap-4 w-5/6 p-4 pl-8 pr-6 rounded-lg font-bold text-3xl text-slate-600 bg-gray-100 border">
      <span>{{ formattedDuration }}</span>
    </div>
    <!-- TODO: Add info box to learn more about how targets are calculated. -->
    <!-- TODO: Enable the callout below once figured out a way to calculate recommended sleep duration. Also add in if it higher, lower, same. -->
    <!-- <div class="w-5/6 p-4 rounded-lg bg-blue-100 text-left">
      <span>Based on your sleep data, this is the recommended sleep duration.</span>
    </div> -->

    <!-- TODO: Move this to a timepicker component. -->
    <!-- Timepicker for wake time. -->
    <v-dialog
      v-model="wakeTimepicker"
      width="auto"
    >
      <v-time-picker
        ampm-in-title
        v-model="timeWake"
        :allowed-minutes="allowedStep"
      />
    </v-dialog>
    <!-- Duration selector -->
    <DurationSelector
      v-model:duration="duration"
      v-model:showSelector="durationSelector"
    />
  </ModalContainer>
</template>

<script>
import ModalContainer from '@/components/ModalContainer'
import DurationSelector from '@/components/DurationSelector'
import { getXDaysAgo, time24To12, formatDuration, subtractDurationFromTime, roundUp15Minutes } from '@/helpers/time'
import Target from '@/models/target'
import { mapStores } from 'pinia'
import { useUserStore } from '@/stores/user'

export default {
  name: 'SleepTargets',
  components: {
    ModalContainer,
    DurationSelector,
  },
  props: {
    button: {
      type: String,
      default: 'Save',
    },
    title: {
      type: String,
      default: 'Set your sleep target',
    },
    text: {
      type: String,
      default: 'Consistency is the most important part of getting good sleep every night!',
    },
    disableClose: Boolean,
  },
  emits: [
    'update:modelValue',
    'save-function',
  ],
  data() {
    return {
      modelValue: false,
      // TODO: Change this so that it is based on user data.
      duration: 450,
      timeBed: undefined,
      timeWake: undefined,
      time: undefined,
      wakeTimepicker: false,
      bedTimepicker: false,
      durationSelector: false,
      targetId: undefined,
    }
  },
  beforeMount() {
    this.userStore.user.getSleepTarget()
      .then(target => {
        if (target) {
          this.targetId = target.id

          // Defaults for all of these are set during onboarding.
          this.duration = target.duration / 60
          this.timeBed = target.bedTime
          this.timeWake = target.wakeTime

          // Get sleep efficiency (past 30 days).
          const date = getXDaysAgo(30)
          return this.userStore.user.getSleepEfficiency(date.start, date.end)
        }
      })
      .then(efficiency => {
          this.efficiency = efficiency
          this.opportunity = this.duration / this.efficiency
      })
  },
  watch: {
    timeWake() {
      if (!this.opportunity) {
        return
      }
      this.timeBed = roundUp15Minutes(subtractDurationFromTime(this.timeWake, this.opportunity * 60, true), true)
    },
    duration() {
      if (!this.opportunity || !this.efficiency) {
        return
      }
      this.opportunity = this.duration / this.efficiency
      this.timeBed = roundUp15Minutes(subtractDurationFromTime(this.timeWake, this.opportunity * 60, true), true)
    },
  },
  methods: {
    showModal() {
      this.modal = true
    },
    formatTime(t) {
      return time24To12(t)
    },
    allowedStep: m => m % 5 === 0,
    async onButtonClick() {
      // Write new targets to the database.
      this.userStore.user.saveSleepTarget(new Target(
        this.duration * 60,
        this.timeBed,
        this.timeWake,
        this.targetId,
        true,
      ))

      // Close modal after the write is done.
      this.modal = false

      // Only after all that, emit the `save-function` event for the parent to do whatever.
      this.$emit('save-function', this.timeBed, this.timeWake)
    },
  },
  computed: {
    formattedDuration() {
      return formatDuration(this.duration)
    },
    modal: {
      get() {
        return this.modelValue
      },
      set(value) {
        this.$emit('update:modelValue', value)
      },
    },
    ...mapStores(useUserStore),
  },
}
</script>